import { Box, Button, Grid, styled, Typography } from "@mui/material";
import {
  DataGrid,
  GridColDef,
  GridToolbar,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import * as React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useFetchAllDivisi from "../../../../api/effects/queries/Divisi/useFetchAllDivisi";
import { DivisiResponse } from "../../../../models/Divisi";
import { CustomToolbar } from "../../HeaderHR";
import DivisiModal from "./DivisiModal";

const BoxTable = styled(Box)({
  height: "70vh",
  width: "100%",
  maxWidth: "1280px",
});

export default function DivisiTable() {
  const columns: GridColDef[] = [
    {
      field: "DIVISI_ID",
      headerName: "Divisi ID",
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    { field: "DIVISI", headerName: "Divisi", flex: 1 },
    {
      field: "IS_ACTIVE",
      headerName: "Is Active",
      type: "boolean",
      flex: 1,
    },
    {
      field: "action",
      headerName: "Action",
      sortable: false,
      renderCell: (params: GridValueGetterParams) => {
        const onClick = () => {
          handleOpenModalEdit(params.row.DIVISI_ID);
        };
        return <Button onClick={onClick}>Edit</Button>;
      },
      headerAlign: "center",
      align: "center",
    },
  ];
  const { data: allDivisiData } = useFetchAllDivisi();

  const [data, setData] = useState<DivisiResponse[]>();

  useEffect(() => {
    if (allDivisiData !== undefined) {
      setData(allDivisiData);
    }
  }, [allDivisiData]);

  const [IDState, setIDState] = useState(-1);
  const [modalState, setModalState] = useState(false);

  const handleOpenModalAdd = () => {
    setIDState(-1);
    setModalState(!modalState);
  };
  const handleOpenModalEdit = (e: number) => {
    setIDState(e);
    setModalState(!modalState);
  };

  const handleCloseModal = () => {
    setModalState(!modalState);
  };

  return (
    <>
      <DivisiModal
        open={modalState}
        handleClose={handleCloseModal}
        ID={IDState}
      />
      <Grid
        container
        justifyContent="flex-start"
        sx={{
          maxWidth: "1280px",
          paddingBottom: "1vh",
        }}
      >
        <Typography variant="h4">Tabel Divisi</Typography>
      </Grid>
      <BoxTable>
        {data !== undefined ? (
          <DataGrid
            rows={data}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            getRowId={(data) => data.DIVISI_ID}
            disableColumnMenu
            components={{ Toolbar: CustomToolbar }}
          />
        ) : (
          <div />
        )}
      </BoxTable>
      <Grid
        container
        justifyContent="flex-end"
        sx={{
          maxWidth: "1280px",
          paddingTop: "2vh",
        }}
      >
        <Button variant="contained" onClick={handleOpenModalAdd}>
          Tambah Divisi
        </Button>
      </Grid>
    </>
  );
}
